import { render } from "./WritePrescriptionPage.vue?vue&type=template&id=67d6884c&ts=true"
import script from "./WritePrescriptionPage.vue?vue&type=script&lang=ts"
export * from "./WritePrescriptionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__